<script setup lang="ts">
import { ref } from 'vue'
import { useSectionReveal } from '../composables/useSectionReveal'
import type { LocaleCode, LocalizedCopy, ProtectionMethod } from '../types/site'
import { localized } from '../utils/localized'
import IconSprite from './IconSprite.vue'
import SectionTitle from './SectionTitle.vue'

defineProps<{
  methods: ProtectionMethod[]
  copy: LocalizedCopy
  locale: LocaleCode
  fallbackLocale: LocaleCode
  watermarkImage: string
}>()

const sectionRoot = ref<HTMLElement | null>(null)
const { active } = useSectionReveal(sectionRoot)

</script>

<template>
  <section id="collection-protection" ref="sectionRoot" class="protection-section page-section" data-track-section="protection">
    <SectionTitle
      eyebrow="COLLECTION PROTECTION"
      :title="copy.protection.title"
      :watermark="watermarkImage"
    />

    <div class="protection-section__lead">
      <strong>{{ copy.protection.subtitle }}</strong>
      <p>{{ copy.protection.intro }}</p>
    </div>

    <div class="protection-grid">
      <article v-for="method in methods" :key="method.id" class="protection-card">
        <div class="protection-card__copy">
          <h3>{{ localized(method.title, locale, fallbackLocale) }}</h3>
          <p>{{ localized(method.description, locale, fallbackLocale) }}</p>
        </div>
        <span
          class="icon-motion protection-card__art"
          :class="`protection-card__art--${method.id}`"
        >
          <IconSprite v-if="method.sprite" :sprite="method.sprite" :active="active" />
          <img
            v-else
            class="icon-motion__image"
            :src="method.image"
            alt=""
            loading="lazy"
            decoding="async"
          />
        </span>
      </article>
    </div>
  </section>
</template>
